import React from 'react';

function AvatarPlaceholder({ placeholderFontSize, placeholderText }) {
	return (
		<div className="avatar-placeholder">
			<span
				className="placeholder-text"
				style={{ fontSize: `${placeholderFontSize}px` }}>
				{placeholderText}
			</span>
		</div>
	);
}

function AvatarImage({
	src,
	alt,
	placeholderFontSize = 60,
	placeholderText = 'A',
	...props
}) {
	const isURLAbsolute = url => {
		return url.indexOf('://') > 0 || url.indexOf('//') === 0;
	};
	const buildAbsoluteURL = url => {
		return `${process.env.REACT_APP_API}${url}`;
	};

	return (
		<div className="avatar-image">
			{src ? (
				<img
					src={src ? (!isURLAbsolute(src) ? buildAbsoluteURL(src) : src) : null}
					alt={alt || ''}
					{...props}
				/>
			) : (
				<AvatarPlaceholder
					placeholderFontSize={placeholderFontSize}
					placeholderText={placeholderText}
				/>
			)}
		</div>
	);
}

export default AvatarImage;
